const actions = {
  LOAD_NEWS: "LOAD_NEWS",
  LOAD_NEWS_DETAIL: "LOAD_NEWS_DETAIL",
  SET_NEWS_ITEM_VALUE: "SET_NEWS_ITEM_VALUE",
  ADD_FILES_TO_NEWS: "ADD_FILES_TO_NEWS",
  LOAD_NEWS_TAGS: "LOAD_NEWS_TAGS",

  LOAD_TAGS_BY_NEWS: "LOAD_TAGS_BY_NEWS",

  TAGS_BY_NEWS_ARE_LOADING: "TAGS_BY_NEWS_ARE_LOADING",

  ALL_NEWS_TAGS_ARE_LOADING: 'ALL_NEWS_TAGS_ARE_LOADING',

  LOAD_NEWS_CONTENT: "LOAD_NEWS_CONTENT",
  CONTENT_BY_NEWS_IS_LOADING: "CONTENT_BY_NEWS_IS_LOADING",

  ADD_TITLE_IMAGE_TO_NEWS: "ADD_TITLE_IMAGE_TO_NEWS",
  NEWS_ARE_LOADING: "NEWS_ARE_LOADING",

  LOAD_ADMIN_NEWS: "LOAD_ADMIN_NEWS",
  NEWS_ADMIN_ARE_LOADING: "NEWS_ADMIN_ARE_LOADING",

  ATTACH_FILE_TO_NEWS: "ATTACH_FILE_TO_NEWS",
  ADD_FILE_FORM: "ADD_FILE_FORM",
  NEW_IS_SUBMITTING: "NEW_IS_SUBMITTING"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/portal/news.js